<template>
  <span class="deployment-unit-outlined-icon" :style="iconStyle" aria-hidden="true">
    <!-- 与 Ant Design DeploymentUnitOutlined 一致（项目未装 @ant-design/icons-vue，用内联 SVG） -->
    <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor">
      <path
        d="M888.3 693.2c-42.5-24.6-94.3-18-129.2 12.8l-53-30.7V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-67.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v67.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-53 30.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l48.7-28.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l48.7 28.3c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zm-673 138.4a47.6 47.6 0 01-65.2-17.6c-13.2-22.9-5.4-52.3 17.5-65.5a47.6 47.6 0 0165.2 17.6c13.2 22.9 5.4 52.3-17.5 65.5zM522 463.8zM464 234a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm170 446.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zm239.9 133.9c-13.2 22.9-42.4 30.8-65.2 17.6-22.8-13.2-30.7-42.6-17.5-65.5s42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'DeploymentUnitOutlinedIcon',
  props: {
    size: { type: [Number, String], default: 16 },
  },
  computed: {
    iconStyle() {
      const px = typeof this.size === 'number' ? `${this.size}px` : this.size
      return { fontSize: px }
    },
  },
}
</script>

<style scoped>
.deployment-unit-outlined-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  vertical-align: middle;

  svg {
    display: block;
  }
}
</style>
